<nb-card class="card-shadow otp-card">
  <nb-card-header>
    <div class="otp-instruction">
      Please enter the one-time password to verify your account
    </div>
    <div class="otp-email-info">
      <span>A code has been sent to</span>
      <strong>{{email}}</strong>
    </div>
  </nb-card-header>

  <nb-card-body>
    <form [formGroup]="otpForm" (ngSubmit)="confirmOtp()">
      <div class="otp-inputs" formArrayName="otp">
        <div *ngFor="let control of otpControls.controls; let i = index">
          <input
            nbInput
            [id]="'otp' + i"
            type="text"
            maxlength="1"
            [formControlName]="i"
            (keyup)="moveFocus($event, i)"
            (paste)="handlePaste($event)"
            class="otp-input"
          />
        </div>
      </div>
    </form>
    <div class="otp-timer">
      <p class="otp-timer-text">Time left: <strong>{{ remainingTime }}</strong> seconds</p>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button
      nbButton
      status="success"
      type="submit"
      [disabled]="!otpForm.valid"
      (click)="confirmOtp()"
    >
      Confirm
    </button>
    <button
      nbButton
      status="warning"
      *ngIf="showResendButton"
      (click)="resendOtp()"
    >
      Resend OTP
    </button>
  </nb-card-footer>
</nb-card>
